var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ly-batch-input',{ref:"binput",attrs:{"title":"批量添加货品","example":"编码\n100100\n编码,调账差额\n100100,-560.00"},on:{"confirm":_vm.addProducts}},[_c('template',{slot:"statement"},[_c('p',[_vm._v("批量添加支持:1、按货品编码；2、按货品编码,调账差额；等方式进行添加。批量添加输入框内每一行代表添加一个货品(列用逗号隔开)，注意输入时不要带有空格或其他特殊字符以免添加失败。批量添加完成后请检查后提交单据。")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }